import '../App.css';
import NavBar from './navbar';
import NavMenu from './navmenu';
import CaseList from './caselist';
import leading_the_way from '../assets/Leading_The_Way_Conveyancing.svg';

const Hub = () => {
	return (
		<div className="Home" style={{ position: 'relative' }}>
			<CaseList />
			<div className='mainFooter'>
				<div style={{ marginLeft: '10%', marginRight: '10%', width: '80%', marginTop: 18 }}>
					<img style={{ height: 28 }} src={leading_the_way} alt='LeadingTheWay-Banner' />
				</div>
			</div>
			<div className='loginFooter'></div>
			<NavMenu />
			<NavBar />
		</div>
	);
}

export default Hub;